module.exports = __webpack_public_path__ + "static/media/logoMachen.c1ab9af8.svg";